// extracted by mini-css-extract-plugin
export default {"pageWrapper":"media_pageWrapper__el1rq","blockWrapper":"media_blockWrapper__Y40Om","title":"media_title__FAbLF"};